<template>
  <textarea v-model="input" @keydown="keydown" class="resize-none overflow-auto" />
</template>

<script>
import { useTextareaAutosize } from "@vueuse/core";
export default {
  props: ["value"],
  data() {
    return {
      input: this.value,
    };
  },

  methods: {
    keydown(e) {
      const keyCode = e.keyCode || e.which;

      if (keyCode === 9) {
        e.preventDefault();

        const TAB_SIZE = 2;
        e.target.value += "　".replace(TAB_SIZE);
      }
    },
    resize() {
      useTextareaAutosize({
        element: this.$el,
        input: this.input,
        // styleTarget: this.$el,
        onResize: () => {
          const attrs = this.$parent.$attrs;          
          let { ratio, rows, maxRows } = attrs;
          maxRows = maxRows ?? attrs['max-rows'];
          ratio = ratio ? ratio : 1.5;
          // calulate min height by attribute rows
          this.$el.style.minHeight = `${rows * ratio}rem`;

          // calulate max height by attribute rows
          if (maxRows) {
            this.$el.style.maxHeight = `${maxRows * ratio}rem`;
          }
        },
        watch: () => {
          this.$emit("input", this.input);
          
        },
      });
    },
  },
  watch: {
    value(val) {
      this.input = val;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.resize();
    });
  },
  
};
</script>
